import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/2fa-picture.jpg'


const _hoisted_1 = { class: "container login sm-pdt-100 justify-content-center" }
const _hoisted_2 = { class: "w-100 d-flex justify-content-center align-items-center sm-vh-auto" }
const _hoisted_3 = { class: "w-100 d-flex flex-column justify-content-center align-items-lg-start align-items-center" }
const _hoisted_4 = { class: "text-md-start text-center" }
const _hoisted_5 = { class: "form-group d-flex flex-column gap-4 mb-4 align-items-lg-start align-items-center" }
const _hoisted_6 = {
  for: "code",
  class: "text-md-start text-center"
}
const _hoisted_7 = { class: "d-flex gap-4 mt-4" }
const _hoisted_8 = { class: "mt-3 d-flex justify-content-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "text-danger mt-2 pdl-10 pdr-10"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 hide-mobile" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"max-width":"100%","max-height":"90vh"},
    class: "rounded img-fluid",
    src: _imports_0,
    alt: "2FA Image"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicHeader = _resolveComponent("PublicHeader")!
  const _component_VerificationCodeInput = _resolveComponent("VerificationCodeInput")!
  const _component_PublicFooter = _resolveComponent("PublicFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PublicHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, "Check Your " + _toDisplayString($setup.method), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, "We've sent you a code to " + _toDisplayString($setup.sentTo), 1),
            _createVNode(_component_VerificationCodeInput, {
              modelValue: $setup.verificationCode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.verificationCode) = $event)),
              "extra-classes": "centered",
              onKeyup: _withKeys($setup.verifyCode, ["enter"])
            }, null, 8, ["modelValue", "onKeyup"]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.verifyCode && $setup.verifyCode(...args))),
                class: "btn btn-primary w-100"
              }, "Submit Code")
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.regenerateCode && $setup.regenerateCode(...args)), ["prevent"]))
                }, "Resend Code"),
                ($setup.timer > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, " (" + _toDisplayString($setup.timer) + " seconds remaining)", 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            ($setup.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_11
      ])
    ]),
    _createVNode(_component_PublicFooter)
  ], 64))
}